import React, { useState } from "react";
import { isBrowser, isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import LargeModal from "../../../../components/modals/LargeModal";
import { readyPharmacyOrder } from "../../../../redux/actions/dashboard";
import {
  closePharmacyOrderReadyModal,
  openPrescriptionModal,
} from "../../../../redux/actions/modals";
import toaster from "../../../../utils/toaster";

const PharmacyOrderReadyComponent = (props) => {
  const dispatch = useDispatch();
  const [pharmacyVerify, setPharmacyVerify] = useState({});
  const { pharmacy_order_ready_open, pharmacy_order_ready_order } = useSelector(
    (state) => state.modals
  );
  const { ready_pharmacy_order_waiting } = useSelector(
    (state) => state.dashboard
  );
  const prescriptionIsReady = () => {
    let items = [];
    Object.entries(pharmacyVerify).forEach((item) => {
      items.push(item[1]);
    });
    if (items.length < pharmacy_order_ready_order.prescriptions.length) {
      toaster.error(
        "لطفا توضیحات لازم در ارتباط با نحوه صحیح مصرف دارو و تداخلات احتمالی را وارد کنید"
      );
      return;
    }
    let error = false;
    items.forEach((item) => {
      if (item.verify === "text" && item.description.length <= 5) {
        error = true;
      }
    });
    if (error) {
      toaster.error(
        "لطفا توضیحات لازم در ارتباط با نحوه صحیح مصرف دارو و تداخلات احتمالی را وارد کنید (حداقل ۲۰  کاراکتر)"
      );
      return;
    }
    console.log({ data: pharmacyVerify });
    dispatch(
      readyPharmacyOrder(pharmacy_order_ready_order.id, {
        data: pharmacyVerify,
      })
    );
  };

  return (
    <>
      <LargeModal
        header="توضیحات لازم در ارتباط با نحوه صحیح مصرف دارو و تداخلات احتمالی"
        show={pharmacy_order_ready_open}
        closeFunction={closePharmacyOrderReadyModal}
      >
        <div>
          {pharmacy_order_ready_order.prescriptions
            ? pharmacy_order_ready_order.prescriptions.map(
                (prescription, index) => {
                  return (
                    <div className="pharmacy-items-recommendations" key={index}>
                      <div className="prescription-image-holder">
                        <img
                          src={prescription.url}
                          width={60}
                          alt="prescription"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            dispatch(openPrescriptionModal(prescription.url));
                          }}
                        />
                      </div>
                      {isBrowser ? (
                        <div style={{ width: "100%" }}>
                          <div className="form-group row">
                            <div className="col-sm-2">
                              <input
                                type="radio"
                                name={"recommendation-type-" + prescription.id}
                                id={
                                  "recommendation-type-phone-" + prescription.id
                                }
                                value="phone"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setPharmacyVerify((prevState) => ({
                                    ...prevState,
                                    [prescription.id]: {
                                      verify: value,
                                      description:
                                        prevState[prescription.id] !== undefined
                                          ? prevState[prescription.id][
                                              "description"
                                            ]
                                          : "",
                                    },
                                  }));
                                }}
                              />
                            </div>
                            <label
                              className="col-sm-10 col-form-label"
                              htmlFor={
                                "recommendation-type-phone-" + prescription.id
                              }
                            >
                              به صورتی تلفنی به اطلاع کاربر رسید.
                            </label>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-2">
                              <input
                                type="radio"
                                name={"recommendation-type-" + prescription.id}
                                id={
                                  "recommendation-type-text-" + prescription.id
                                }
                                value="text"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setPharmacyVerify((prevState) => ({
                                    ...prevState,
                                    [prescription.id]: {
                                      verify: value,
                                      description:
                                        prevState[prescription.id] !== undefined
                                          ? prevState[prescription.id][
                                              "description"
                                            ]
                                          : "",
                                    },
                                  }));
                                }}
                              />
                            </div>
                            <label
                              className="col-sm-10 col-form-label"
                              htmlFor={
                                "recommendation-type-text-" + prescription.id
                              }
                            >
                              در کادر زیر برای کاربر یادداشت میشود
                            </label>
                          </div>
                          <div className="form-group row">
                            <label
                              className="col-sm-2 col-form-label"
                              style={{ textAlign: "left" }}
                            >
                              توضیحات :
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="توضیحات در مورد نحوه مصرف دارو"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setPharmacyVerify((prevState) => ({
                                    ...prevState,
                                    [prescription.id]: {
                                      verify:
                                        prevState[prescription.id] !== undefined
                                          ? prevState[prescription.id]["verify"]
                                          : "",
                                      description: value,
                                    },
                                  }));
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-2">
                              <input
                                type="radio"
                                name={"recommendation-type-" + prescription.id}
                                id={
                                  "recommendation-type-doctor-suggestion-" +
                                  prescription.id
                                }
                                value="doctor_suggestion"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setPharmacyVerify((prevState) => ({
                                    ...prevState,
                                    [prescription.id]: {
                                      verify: value,
                                      description:
                                        prevState[prescription.id] !== undefined
                                          ? prevState[prescription.id][
                                              "description"
                                            ]
                                          : "",
                                    },
                                  }));
                                }}
                              />
                            </div>
                            <label
                              className="col-sm-10 col-form-label"
                              htmlFor={
                                "recommendation-type-doctor-suggestion-" +
                                prescription.id
                              }
                            >
                              طبق توصیه پزشک مصرف شود.
                            </label>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-2">
                              <input
                                type="radio"
                                name={"recommendation-type-" + prescription.id}
                                id={
                                  "recommendation-type-on-product-" +
                                  prescription.id
                                }
                                value="on_product"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setPharmacyVerify((prevState) => ({
                                    ...prevState,
                                    [prescription.id]: {
                                      verify: value,
                                      description:
                                        prevState[prescription.id] !== undefined
                                          ? prevState[prescription.id][
                                              "description"
                                            ]
                                          : "",
                                    },
                                  }));
                                }}
                              />
                            </div>
                            <label
                              className="col-sm-10 col-form-label"
                              htmlFor={
                                "recommendation-type-on-product-" +
                                prescription.id
                              }
                            >
                              نحوه مصرف روی محصول چسبانده شده است.
                            </label>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-2">
                              <input
                                type="radio"
                                name={"recommendation-type-" + prescription.id}
                                id={
                                  "recommendation-type-none-" + prescription.id
                                }
                                value="none"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setPharmacyVerify((prevState) => ({
                                    ...prevState,
                                    [prescription.id]: {
                                      verify: value,
                                      description:
                                        prevState[prescription.id] !== undefined
                                          ? prevState[prescription.id][
                                              "description"
                                            ]
                                          : "",
                                    },
                                  }));
                                }}
                              />
                            </div>
                            <label
                              className="col-sm-10 col-form-label"
                              htmlFor={
                                "recommendation-type-none-" + prescription.id
                              }
                            >
                              مشاوره دارویی انجام نشد.
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div style={{ width: "100%", textAlign: "right" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              type="radio"
                              name={"recommendation-type-" + prescription.id}
                              id={
                                "recommendation-type-phone-" + prescription.id
                              }
                              value="phone"
                              onChange={(e) => {
                                const value = e.target.value;
                                setPharmacyVerify((prevState) => ({
                                  ...prevState,
                                  [prescription.id]: {
                                    verify: value,
                                    description:
                                      prevState[prescription.id] !== undefined
                                        ? prevState[prescription.id][
                                            "description"
                                          ]
                                        : "",
                                  },
                                }));
                              }}
                            />
                            <label
                              style={{
                                fontSize: "12px",
                                marginRight: "15px",
                                marginBottom: "0px",
                              }}
                              htmlFor={
                                "recommendation-type-phone-" + prescription.id
                              }
                            >
                              به صورتی تلفنی به اطلاع کاربر رسید.
                            </label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              type="radio"
                              name={"recommendation-type-" + prescription.id}
                              id={"recommendation-type-text-" + prescription.id}
                              value="text"
                              onChange={(e) => {
                                const value = e.target.value;
                                setPharmacyVerify((prevState) => ({
                                  ...prevState,
                                  [prescription.id]: {
                                    verify: value,
                                    description:
                                      prevState[prescription.id] !== undefined
                                        ? prevState[prescription.id][
                                            "description"
                                          ]
                                        : "",
                                  },
                                }));
                              }}
                            />
                            <label
                              style={{
                                fontSize: "12px",
                                marginRight: "15px",
                                marginBottom: "0px",
                              }}
                              htmlFor={
                                "recommendation-type-text-" + prescription.id
                              }
                            >
                              در کادر زیر برای کاربر یادداشت میشود
                            </label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              marginBottom: "10px",
                              width: "100%",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ textAlign: "right", width: "35%" }}
                            >
                              توضیحات :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="توضیحات در مورد نحوه مصرف دارو"
                              onChange={(e) => {
                                const value = e.target.value;
                                setPharmacyVerify((prevState) => ({
                                  ...prevState,
                                  [prescription.id]: {
                                    verify:
                                      prevState[prescription.id] !== undefined
                                        ? prevState[prescription.id]["verify"]
                                        : "",
                                    description: value,
                                  },
                                }));
                              }}
                              style={{ width: "100%" }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              type="radio"
                              name={"recommendation-type-" + prescription.id}
                              id={
                                "recommendation-type-doctor-suggestion-" +
                                prescription.id
                              }
                              value="doctor_suggestion"
                              onChange={(e) => {
                                const value = e.target.value;
                                setPharmacyVerify((prevState) => ({
                                  ...prevState,
                                  [prescription.id]: {
                                    verify: value,
                                    description:
                                      prevState[prescription.id] !== undefined
                                        ? prevState[prescription.id][
                                            "description"
                                          ]
                                        : "",
                                  },
                                }));
                              }}
                            />
                            <label
                              style={{
                                fontSize: "12px",
                                marginRight: "15px",
                                marginBottom: "0px",
                              }}
                              htmlFor={
                                "recommendation-type-text-" + prescription.id
                              }
                            >
                              طبق توصیه پزشک مصرف شود.
                            </label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              type="radio"
                              name={"recommendation-type-" + prescription.id}
                              id={
                                "recommendation-type-on-product-" +
                                prescription.id
                              }
                              value="on_product"
                              onChange={(e) => {
                                const value = e.target.value;
                                setPharmacyVerify((prevState) => ({
                                  ...prevState,
                                  [prescription.id]: {
                                    verify: value,
                                    description:
                                      prevState[prescription.id] !== undefined
                                        ? prevState[prescription.id][
                                            "description"
                                          ]
                                        : "",
                                  },
                                }));
                              }}
                            />
                            <label
                              style={{
                                fontSize: "12px",
                                marginRight: "15px",
                                marginBottom: "0px",
                              }}
                              htmlFor={
                                "recommendation-type-text-" + prescription.id
                              }
                            >
                              نحوه مصرف روی محصول چسبانده شده است.
                            </label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              type="radio"
                              name={"recommendation-type-" + prescription.id}
                              id={"recommendation-type-text-" + prescription.id}
                              value="none"
                              onChange={(e) => {
                                const value = e.target.value;
                                setPharmacyVerify((prevState) => ({
                                  ...prevState,
                                  [prescription.id]: {
                                    verify: value,
                                    description:
                                      prevState[prescription.id] !== undefined
                                        ? prevState[prescription.id][
                                            "description"
                                          ]
                                        : "",
                                  },
                                }));
                              }}
                            />
                            <label
                              style={{
                                fontSize: "12px",
                                marginRight: "15px",
                                marginBottom: "0px",
                              }}
                              htmlFor={
                                "recommendation-type-text-" + prescription.id
                              }
                            >
                              مشاوره دارویی انجام نشد
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }
              )
            : null}
          <div>
            <CustomButton
              className="btn btn-small btn-success text-white"
              action={prescriptionIsReady}
              loading={ready_pharmacy_order_waiting}
              content={"تایید و درخواست پیک"}
              type={"success"}
              textWhite={true}
              block={true}
              style={isMobile ? { fontSize: "12px" } : {}}
            />
          </div>
        </div>
      </LargeModal>
    </>
  );
};
export default PharmacyOrderReadyComponent;
